// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Home/Content/Tasks/Content/CommentsLogs/Comments/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Content_Home_Content_Tasks_Content_CommentsLogs_Comments_Content($id: uuid!) {
  tasks_comments(
    where: { task_id: { _eq: $id } }
    order_by: { created_at: desc }
  ) {
    id
    value
    created_at
    created_by_user {
      id
      vaxiom_person {
        id
        first_name
        last_name
      }
    }
  }
}

`